export enum CapabilityModelSchemaType {
    Telemetry,
    Property,
    Command,
    State,
}
